import React from "react";
import { useLang } from "../i18n/LanguageContext";

const ABOUT_IMG = "https://images.unsplash.com/photo-1646324554833-f0b6a479fa5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjBmcmFtaW5nJTIwYnVpbGRlcnxlbnwwfHx8fDE3ODExMjAzMjZ8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="relative bg-neutral-950 py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <div className="flex items-center gap-3 text-orange-500 font-mono-label text-xs uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-orange-500" /> {t.about.label}
          </div>
          <h2 className="font-display uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] whitespace-pre-line">
            {t.about.title}
          </h2>
          <div className="mt-8 space-y-5 text-neutral-300 text-base sm:text-lg leading-relaxed max-w-2xl">
            <p>{t.about.body1}</p>
            <p>{t.about.body2}</p>
          </div>
          <div className="mt-10 inline-flex items-center gap-3 border-l-4 border-orange-500 pl-5 py-2">
            <span className="font-display uppercase text-white text-xl sm:text-2xl tracking-tight">{t.about.tag}</span>
          </div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2 relative">
          <div className="aspect-[4/5] overflow-hidden rounded-sm border border-neutral-800 relative">
            <img src={ABOUT_IMG} alt="Craftsmanship" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -left-6 sm:-left-10 bg-orange-500 text-black p-5 sm:p-6 rounded-sm shadow-2xl max-w-[220px]">
            <div className="font-display text-4xl sm:text-5xl leading-none">10+</div>
            <div className="text-xs uppercase tracking-wider font-bold mt-2">Years on the tools · Birmingham, AL</div>
          </div>
        </div>
      </div>
    </section>
  );
}
